module.exports = require('./helpers/bundle-url').getBundleURL('iwMWQ') + "logo.c51670a8.svg";